import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TinselPayService } from '../tinsel-pay.service';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// Extend dayjs with plugins
dayjs.extend(utc);
dayjs.extend(timezone);

import { Subject, debounceTime } from 'rxjs';
import { LoaderService } from '../shared/services/loader.service';
import { NgxSpinnerComponent } from 'ngx-spinner';
import { NgIf, NgFor, CurrencyPipe } from '@angular/common';
import { DatePickerControllerComponent } from '../date-picker-controller/date-picker-controller.component';

@Component({
    selector: 'app-tinsel-pay-overview-ach-transactions',
    templateUrl: './tinsel-pay-overview-ach-transactions.component.html',
    styleUrls: ['./tinsel-pay-overview-ach-transactions.component.css'],
    imports: [DatePickerControllerComponent, NgIf, NgFor, NgxSpinnerComponent, CurrencyPipe]
})
export class TinselPayOverviewAchTransactionsComponent implements OnInit {
  //Screensize event Listener
  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.resizeSubject.next((event.target as Window).innerWidth);
  }

  // Variable Subject
  private resizeSubject: Subject<number> = new Subject<number>();

  // Properties
  @ViewChild('TRANSACTION_DETAILS_MODAL') private transactionDetailsModal: ElementRef;
  private modalReference: NgbModalRef;
  transactions: any[] = [];
  startDate: string;
  endDate: string;
  selectedTransaction: any;
  isMobileView: boolean = false;

  // Get isMobile value in reactive way
  public get isMobile(): boolean {
    return this.isMobileView;
  }

  constructor(private tinselPayService: TinselPayService,
    private modalService: NgbModal,
    private loaderService: LoaderService) {
      this.resizeSubject.pipe(
        debounceTime(100)
      ).subscribe(width => {
        if (width <= 768) {
          this.checkScreenSize(width);
        } else {
          this.isMobileView = false;
        }
      });
  }


  ngOnInit(): void {
    this.checkScreenSize();
  }

  ngOnDestroy(): void {
    this.modalService.hasOpenModals() && this.modalService.dismissAll();
  }

  // Get Tinsel Pay ACH Not Closed Transactions
  private getTinselPayAchNotClosedTransactions(): void {
    const params: any = {
      startDate: this.startDate,
      endDate: this.endDate
    };
    this.tinselPayService.getTinselPayAchNotClosedTransactions(params).subscribe(
      {
        next: (transactions) => {
          this.transactions = transactions;
          this.loaderService.hideSpinner(700);
        },
        error: () => {
          this.loaderService.hideSpinner(700);
        }
      }
      );
  }

  // Date Changed
  dateChanged(event: { startDate: string, endDate: string, isAuto: boolean }): void {
    this.loaderService.showSpinner();
    this.startDate = event.startDate;
    this.endDate = event.endDate;
    this.getTinselPayAchNotClosedTransactions();
  }

  // Select Transaction
  selectTransaction(transaction: any): void {
    this.selectedTransaction = transaction;
    this.modalReference = this.modalService.open(this.transactionDetailsModal, { scrollable: true });
  }

  /* ----- Helper Functions ----- */

  // Format Date Time
  formatDateTime(dateTime: string): string {
    if (dateTime === null) return 'N/A';
    return dayjs.tz(dateTime, 'YYYY-MM-DDTHH:mm:ss.SSS[Z]', 'America/Los_Angeles').local().format('M/D/YYYY, h:mm A');
  }

  //Set isMobile value and set table limit base on screen size
  checkScreenSize(width?: number) {
    let screenWidth = width || window.innerWidth;
    this.isMobileView =  screenWidth <= 768;
  }
}
